import { all, takeLatest, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './action'
import axiosMethod from '../../utilities/apiCaller'

const { cAPrivateGet, cAPrivatePost } = axiosMethod

const getBenficiariesListById = token => {
  return cAPrivateGet(`beneficiaries`, token).then(response => {
    return response.data.data
  })
}

export function* getBenficiariesById(values) {
  try {
    const response = yield call(getBenficiariesListById, values.token)
    yield put({
      type: actions.GET_BENEFICIARY_LIST_ID_SUCCESS,
      value: response.beneficiaries,
    })
    // notification.success({
    //   message: response.message,
    // })
  } catch (err) {
    yield put({
      type: actions.GET_BENEFICIARY_LIST_ID_FAILURE,
      payload: err,
    })
    notification.error({
      message: err.response.data.message,
    })
  }
}

const getQuoteDetails = (value, token) => {
  const { sellCurrency, buyCurrency } = value
  const buycurrency = buyCurrency ? `?buyCurrency=${buyCurrency}` : ''
  const sellcurrency = sellCurrency ? `&sellCurrency=${sellCurrency}` : ''
  return cAPrivateGet(`quote${buycurrency}${sellcurrency}`, token).then(response => {
    return response.data.data
  })
}

export function* getQuote(values) {
  try {
    const response = yield call(getQuoteDetails, values.value, values.token)
    yield put({
      type: actions.GET_QUOTE_SUCCESS,
      value: response.quote,
    })
    // notification.success({
    //   message: response.message,
    // })
  } catch (err) {
    yield put({
      type: actions.GET_QUOTE_FAILURE,
      payload: err,
    })
    // notification.error({
    //   message: err.response.data.message,
    // })
  }
}

const initiatePayment = (body, token) => {
  return cAPrivatePost(`payments`, body, token).then(response => {
    return response.data.data
  })
}

export function* newPayment(values) {
  try {
    const response = yield call(initiatePayment, values.value, values.token)
    yield put({
      type: actions.INITIATE_DIGITAL_PAYMENT_SUCCESS,
      value: response,
    })
    yield put({
      type: actions.SET_TO_INITIAL_VALUES,
      value: '',
    })
    notification.success({
      message: response.message,
    })
  } catch (err) {
    yield put({
      type: actions.INITIATE_DIGITAL_PAYMENT_FAILURE,
      payload: err.response.data.data.errors,
    })
    notification.error({
      message: 'Something went wrong ! Check errors for more details...',
    })
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(actions.GET_BENEFICIARY_LIST_ID, getBenficiariesById),
    takeLatest(actions.GET_QUOTE, getQuote),
    takeLatest(actions.INITIATE_DIGITAL_PAYMENT, newPayment),
  ])
}
